// @flow
import React from "react";
import { images } from '../../../../config';
import AddressRow from "../../../Address/AddressRow/AddressRow";
import FloatingAddressContainer from "../../../FloatingAddressContainer/FloatingAddressContainer";
import {ProposalBoxAddressLabel} from "../../../Address/AddressesStyle";

type OwnProps = {
    pickupAddress: string,
    dropoffAddress: string,
}

const ProposalTop = (props: OwnProps) => {
    return (
        <FloatingAddressContainer
            topRow={{
                children: (<AddressRow
                    pinImageMain={{src: images.proposal_pickup_pin, alt: "pickup_pin"}}
                    addressField={
                        <ProposalBoxAddressLabel>
                            {props.pickupAddress || ""}
                        </ProposalBoxAddressLabel>
                    }
                />)
            }}
            bottomRow={{
                children: (<AddressRow
                    pinImageMain={{src: images.proposal_dropoff_pin, alt: "dropoff_pin"}}
                    addressField={
                        <ProposalBoxAddressLabel>
                            {props.dropoffAddress || ""}
                        </ProposalBoxAddressLabel>
                    }
                />)
            }}
        />);
};

export default ProposalTop;



// WEBPACK FOOTER //
// ./src/Components/Screen/Proposal/ProposalTop/ProposalTop.js